// extracted by css-extract-rspack-plugin
export default {"cls1":"AcademiaIcon-cls1_eQn","cls2":"AcademiaIcon-cls2_ITN AcademiaIcon-cls1_eQn"};